import React from 'react';
import { PartialField } from '@niaratech/devcase-crud';
import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { currencies } from '../currencyExchangeRule';
export default fillCrudMetadataGaps({
  label: 'Extra',
  labelPlural: 'Extras',
  name: 'Addon',
  namePlural: 'Addons',
  authorization: authorization('consultant', 'admin'),
  deletable: false,
  custom_withAudit: true,
  dynamoDB: {
    tableName: 'SpearAddon'
  },
  columns: ['id', 'name', 'propertyName', 'type', 'pricingType', 'enabled'],
  fields: [{
    custom_group: 'general',
    name: 'enabled',
    label: 'Ativo',
    default: false,
    required: true,
    type: 'boolean'
  }, {
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    custom_group: 'general',
    name: 'propertyId',
    label: 'Propriedade',
    type: 'text',
    inputType: 'InputHotelDestination',
    nameField: 'propertyName',
    formGroupDisposition: 'HORIZONTAL',
    contentSearchSize: 30,
    listSize: 10,
    allowRules: true,
    notGroup: true,
    contentType: 'property',
    newSearch: true,
    conditionalRequired: i => ['ROOM_SERVICES_BUNDLE'].includes(i.type)
  } as PartialField<any, any>, {
    custom_group: 'general',
    name: 'propertyName',
    label: 'Propriedade (nome)',
    type: 'text',
    renderForm: false
  }, {
    custom_group: 'general',
    name: 'name',
    label: 'Nome',
    type: 'text',
    required: true
  }, {
    custom_group: 'general',
    name: 'description',
    label: 'Descrição',
    type: 'textarray',
    inputType: 'textarea',
    required: true
  }, {
    custom_group: 'general',
    name: 'type',
    label: 'Tipo',
    type: 'text',
    options: [{
      label: 'Translado Regular',
      value: 'TRANSPORTATION_REGULAR'
    }, {
      label: 'Translado Privado',
      value: 'TRANSPORTATION_PRIVATE'
    }, {
      label: 'Pacotes de serviços de hospitalidade',
      value: 'ROOM_SERVICES_BUNDLE'
    }, {
      label: 'Refeição',
      value: 'MEAL'
    }, {
      label: 'Serviço',
      value: 'SERVICE'
    }, {
      label: 'Ingresso',
      value: 'TICKET'
    }, {
      label: 'Alimentos e Bebidas',
      value: 'FOOD_AND_BEVARAGES'
    }],
    required: true
  }, {
    custom_group: 'general',
    name: 'mandatoryPurchase',
    label: 'Compra obrigatória',
    hint: 'Se a compra deste extra será obrigatória ao realizar a reserva do quarto.',
    type: 'boolean'
  }, {
    custom_group: 'notification',
    name: 'notificationEmails',
    label: 'E-mails de notificação',
    hint: 'E-mail para notificação e lembrete. A notificação é enviada no momento da venda.',
    type: 'textarray',
    inputType: 'emailArray'
  }, {
    custom_group: 'notification',
    name: 'notificationAdvanceInDays',
    label: 'Lembrete (dias)',
    hint: 'Número de dias antes do agendamento do serviço em que será enviado um lembrete para o e-mail de notificação. Se não houver o agendamento, será considerada a data do check-in.',
    type: 'int'
  }, {
    custom_group: 'schedule',
    name: 'schedule',
    label: 'Agendamento',
    hint: 'Permite que o hóspede especifique uma data (hora) para o agendamento do serviço. O sistema restringe a data (hora) de acordo com a antecedência mínima, mas não considera o período de hospedagem.',
    type: 'boolean'
  }, {
    custom_group: 'schedule',
    name: 'schehuleType',
    label: 'Tipo de agendamento',
    type: 'text',
    options: [{
      label: 'Data',
      value: 'DATE'
    }, {
      label: 'Data e hora',
      value: 'DATETIME'
    }],
    renderForm: e => e.schedule == true,
    conditionalRequired: e => e.schedule == true
  }, {
    custom_group: 'schedule',
    name: 'minAdvanceInHours',
    label: 'Antecendência mínima (horas)',
    hint: 'Número mínimo em horas em que o serviço pode ser comprado ou agendado.',
    type: 'int'
  }, {
    deprecated: true,
    custom_group: 'general',
    custom_groupName: 'Imagens',
    name: 'logo',
    label: 'Logotipo',
    inputType: 'inputPublicFile',
    custom_gerarPrefix: i => i.id + '/logo/',
    hint: 'Dê preferência à imagem com fundo transparente, sem margens.',
    render: false
  }, {
    custom_group: 'general',
    custom_groupName: 'Imagens',
    name: 'images',
    label: 'Imagens',
    hint: 'Imagens que aparecerão na ilustração do extra.',
    type: 'objectarray',
    graphQLType: '[AddonImages]',
    graphQLInputType: '[AddonImagesInput]',
    fields: [{
      name: 'name',
      label: 'Nome',
      required: true,
      type: 'text'
    }, {
      name: 'url',
      label: 'Link imagem',
      required: false,
      type: 'text',
      inputType: 'inputPublicFile'
    }],
    required: false
  }, {
    custom_group: 'price',
    name: 'unit',
    label: 'Unidade',
    hint: 'Usado para orientar o usuário no momento da compra. Ex: escolher "Por pessoa" extras como passeios individuais, refeições. Escolher "por reserva" extras como estacionamento.',
    type: 'text',
    required: true,
    options: [{
      label: 'Por pessoa',
      value: 'PER_GUEST'
    }, {
      label: 'Por reserva',
      value: 'PER_RESERVATION'
    }]
  }, {
    custom_group: 'price',
    name: 'billingType',
    label: 'Cálculo do preço',
    hint: 'Define como calular o valor final da contratação, de acordo com a duração da estadia. Ex: escolher "Por noite" serviços como vaga de garagem, cuidados para pets. Escolher "por estadia" serviços como atividades individuais.',
    type: 'text',
    required: true,
    options: [{
      label: 'Por mês da estadia',
      value: 'BILLING_TYPE_PER_MONTH'
    }, {
      label: 'Por noite da estadia',
      value: 'BILLING_TYPE_PER_DAY'
    }, {
      label: 'Por unidade contratada',
      value: 'BILLING_TYPE_PER_UNIT'
    }]
  }, {
    custom_group: 'price',
    name: 'pricingType',
    label: 'Tipo de preço',
    type: 'text',
    options: [{
      label: 'Preço Único',
      value: 'PRICE'
    }, {
      label: 'Por Tipo de Quarto',
      value: 'ROOM'
    }, {
      label: 'Por Categoria',
      value: 'CATEGORY'
    }, {
      label: 'Por Idade',
      value: 'AGE'
    }],
    required: true
  }, {
    deprecated: true /** restaurar se precisar */,
    name: 'usageStartDate',
    label: 'Período de serviço - Início',
    hint: 'Início da data em que o extra estará disponível para reservar',
    type: 'date',
    render: false
  }, {
    deprecated: true /** restaurar se precisar */,
    name: 'usageEndDate',
    label: 'Período de serviço - Fim',
    hint: 'Final da data em que o extra estará disponível para reservar',
    type: 'date',
    render: false
  }, {
    deprecated: true /** restaurar se precisar */,
    name: 'buyStartDate',
    label: 'Período de venda - Início',
    hint: 'Início da data em que será possível reservar o extra.',
    type: 'date',
    render: false
  }, {
    deprecated: true /** restaurar se precisar */,
    name: 'buyEndDate',
    label: 'Período de venda - Fim',
    hint: 'Final da data em que será possível reservar o extra.                                                                                  O período de reserva é utilizado para campanhas de reservas futuras, limitadas a dias específicos. Se não houver cadastro de período de reserva, será considerado o período de disponibilidade. Exemplo: Este extra deve ser reservado nos dias 01,02 e 03 de Junho para a semana de Natal. tem menu de contexto',
    type: 'date',
    render: false
  }, {
    deprecated: true /** restaurar se precisar */,
    name: 'weekDays',
    label: 'Dias da Semana',
    default: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    options: [{
      label: 'Domingo',
      value: 'sun'
    }, {
      label: 'Segunda-feira',
      value: 'mon'
    }, {
      label: 'Terça-feira',
      value: 'tue'
    }, {
      label: 'Quarta-feira',
      value: 'wed'
    }, {
      label: 'Quinta-feira',
      value: 'thu'
    }, {
      label: 'Sexta-feira',
      value: 'fri'
    }, {
      label: 'Sábado',
      value: 'sat'
    }],
    type: 'textarray',
    render: false
  }, {
    deprecated: true,
    name: 'currency',
    label: 'Moeda',
    type: 'text',
    inputType: 'select',
    options: currencies,
    render: false
  }, {
    deprecated: true,
    name: 'value',
    label: 'Valor',
    type: 'float',
    render: false
  }, {
    custom_group: 'price',
    name: 'priceByVariant',
    label: 'Variantes',
    type: 'objectarray',
    graphQLType: '[VariantType]',
    graphQLInputType: '[VariantInputType]',
    hint: 'ATENÇÃO: Qualquer valor além do primeiro não será considerado.',
    fields: [{
      name: 'id',
      label: 'ID',
      type: 'text',
      render: false
    }, {
      name: 'label',
      label: 'Título',
      type: 'text'
      // renderForm: (i) => ['CATEGORY', 'AGE'].includes(i.pricingType),
      // conditionalRequired: (i) => ['CATEGORY', 'AGE'].includes(i.pricingType),
    }, {
      name: 'fromAge',
      label: 'Início Idade',
      default: 0,
      type: 'int'
      // renderForm: (i) => i.pricingType === 'AGE',
      // conditionalRequired: (i) => i.pricingType === 'AGE',
    }, {
      name: 'toAge',
      label: 'Fim Idade',
      default: 120,
      type: 'int'
      // renderForm: (i) => i.pricingType === 'AGE',
      // conditionalRequired: (i) => i.pricingType === 'AGE',
    }, {
      name: 'currency',
      label: 'Moeda',
      required: true,
      type: 'text',
      inputType: 'select',
      options: currencies
    }, {
      name: 'value',
      label: 'Preço',
      type: 'float',
      default: null,
      required: true
    }],
    renderForm: i => ['PRICE', 'CATEGORY', 'AGE'].includes(i.pricingType)
  }, {
    custom_group: 'price',
    name: 'priceByRoomType',
    label: 'Por tipo de quarto/apartamento',
    type: 'objectarray',
    graphQLType: '[AddonPriceByRoomType]',
    graphQLInputType: '[AddonPriceByRoomTypeInput]',
    fields: [{
      name: 'roomId',
      label: 'ID do Quarto',
      type: 'text',
      required: true
    }, {
      name: 'currency',
      label: 'Moeda',
      required: true,
      type: 'text',
      inputType: 'select',
      options: currencies
    }, {
      name: 'value',
      label: 'Preço',
      type: 'float',
      default: null,
      required: true
    }],
    renderForm: i => ['ROOM'].includes(i.pricingType),
    conditionalRequired: i => ['ROOM'].includes(i.pricingType)
  }, {
    deprecated: true,
    custom_groupName: 'Preços por perfis de passageiros',
    name: 'priceByProfile',
    label: 'Preços',
    type: 'objectarray',
    graphQLType: '[AddonPriceByProfile]',
    graphQLInputType: '[AddonPriceByProfileInput]',
    fields: [{
      name: 'fromAge',
      label: 'Início Idade',
      default: 0,
      type: 'int'
    }, {
      name: 'toAge',
      label: 'Fim Idade',
      default: 200,
      type: 'int'
    }, {
      name: 'currency',
      label: 'Moeda',
      required: true,
      type: 'text',
      inputType: 'select',
      options: [{
        value: 'BRL',
        label: 'BRL'
      }]
    }, {
      name: 'value',
      label: 'Valor',
      type: 'float',
      default: null
    }],
    render: false
  }, {
    name: 'extraFieldDefinitions',
    label: 'Formulário de definição de campos extras',
    type: 'objectarray',
    custom_groupName: 'Campos extras',
    custom_renderFieldsRecursively: true,
    fields: [{
      name: 'label',
      label: 'Nome de exibição',
      type: 'text',
      required: true,
      hint: 'Nome curto que será exibido como rótulo do campo'
    }, {
      name: 'name',
      label: 'Nome do campo',
      type: 'text',
      readOnly: true,
      hint: 'Esse campo será preenchido automaticamente'
    }, {
      name: 'question',
      label: 'Pergunta',
      type: 'text',
      hint: 'Será exibido no lugar do campo "Nome de exibição" se preenchido'
    }, {
      name: 'hint',
      label: 'Dica',
      type: 'text',
      hint: 'Informação sobre o preenchimento do campo'
    }, {
      name: 'required',
      label: 'Obrigatório',
      type: 'boolean'
    }, {
      name: 'type',
      label: 'Tipo',
      type: 'text',
      default: 'text',
      required: true,
      options: [{
        value: 'text',
        label: 'Texto'
      }],
      renderForm: false
    }, {
      name: 'subtype',
      label: 'Subtipo',
      type: 'text',
      default: 'FREE',
      required: true,
      options: [{
        value: 'FREE',
        label: 'Texto livre'
      }, {
        value: 'OPTIONS',
        label: 'Lista de opções'
      }, {
        value: 'ADVANCED',
        label: 'Avançado'
      }]
    }, {
      name: 'options',
      label: 'Lista de opções',
      hint: 'Separar as opções por linha. Máximo de 2000 opções.',
      type: 'text',
      inputType: 'textarea',
      renderForm: e => e.subtype === 'OPTIONS',
      conditionalRequired: e => e.subtype === 'OPTIONS'
    }, {
      name: 'inputType',
      label: 'Tipo de Entrada',
      type: 'text',
      default: 'select',
      options: [{
        value: 'select',
        label: 'Escolha de opções'
      }, {
        value: 'textfield',
        label: 'Usuário digita a opção'
      }],
      renderForm: e => e.subtype === 'OPTIONS',
      conditionalRequired: e => e.subtype === 'OPTIONS'
    }, {
      name: 'maxLength',
      label: 'Tamanho máximo',
      hint: 'Quantidade de caracteres máxima permitida',
      type: 'int',
      default: 100,
      renderForm: e => e.subtype === 'FREE' || e.subtype === 'ADVANCED'
    }, {
      name: 'minLength',
      label: 'Tamanho mínimo',
      hint: 'Quantidade de caracteres mínima permitida',
      type: 'int',
      renderForm: e => e.subtype === 'ADVANCED'
    }, {
      name: 'uppercase',
      label: 'Apenas letra maiúscula',
      type: 'boolean',
      renderForm: e => e.subtype === 'ADVANCED'
    }, {
      name: 'lowercase',
      label: 'Apenas letra minúscula',
      type: 'boolean',
      renderForm: e => e.subtype === 'ADVANCED'
    }, {
      name: 'pattern',
      label: 'Padrão',
      hint: 'Expressão regular de validação do campo (RegEx)',
      type: 'text',
      renderForm: e => e.subtype === 'ADVANCED'
    }]
  }, {
    custom_groupName: 'Regra de Cancelamento',
    deprecated: true /** restaurar se precisar */,
    name: 'cancelPolicy',
    label: 'Política de Cancelamento',
    type: 'text',
    inputType: 'textarea',
    render: false
  }, {
    custom_groupName: 'Regra de Cancelamento',
    deprecated: true /** restaurar se precisar */,
    name: 'cancelDeadline',
    label: 'Prazo para cancelar',
    hint: 'Informe quantos dias antes do check-in é permitido cancelar a reserva sem custos.',
    type: 'int',
    default: 0,
    render: false
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }]
});